import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Kiacarensonrentinpune() {



const cardData =
  {
    keyword: 'Kia Carens On Rent in Pune',
    heading: 'Sanavi Travels: Kia Carens On Rent in Pune',
    headingDescription: 'Sanavi Travels provides premium and reliable Kia Carens On Rent in Pune for families, corporate professionals, tourists, and group travelers who seek comfort, space, and modern travel experience. Kia Carens is a stylish and spacious MPV known for its smooth driving performance, advanced safety features, luxurious interiors, and excellent ride quality, making it ideal for city travel as well as long-distance journeys. Whether you need a Kia Carens for airport transfers, railway station pickups, wedding functions, corporate travel, family vacations, or outstation tours from Pune, Sanavi Travels ensures a seamless experience with well-maintained AC and Non-AC vehicles. With ample legroom, comfortable captain-style seating, advanced suspension, and large luggage capacity, Kia Carens is perfect for families and groups who prefer relaxed and fatigue-free travel. Our experienced chauffeurs are well-versed with Pune city routes, highways, expressways, and tourist destinations, ensuring punctual pickups, safe driving, and smooth journeys. Transparent pricing, flexible rental plans, professional service standards, and 24/7 customer support make Sanavi Travels a trusted choice for Kia Carens cab rental in Pune, delivering a premium yet affordable travel solution for every occasion.',

    top: 'Popular Travel Uses for Kia Carens On Rent in Pune',


"topPlaces": [
  {
    "title": "Kia Carens for Airport Transfers in Pune",
    "description": "Kia Carens is an excellent choice for Pune airport pickups and drops due to its spacious boot, comfortable seating, and smooth ride quality. Families and corporate travelers prefer Kia Carens for airport travel as it easily accommodates passengers along with large luggage, ensuring stress-free and punctual transfers even during peak traffic hours."
  },
  {
    "title": "Kia Carens for Railway Station Pickup and Drop",
    "description": "Travelers heading to or from Pune railway stations often book Kia Carens cabs for their comfort and reliability. The vehicle offers ample legroom, smooth city navigation, and sufficient luggage space, making it ideal for families and groups traveling with heavy bags."
  },
  {
    "title": "Outstation Travel from Pune",
    "description": "Kia Carens is widely preferred for outstation journeys from Pune to destinations like Mumbai, Lonavala, Mahabaleshwar, Shirdi, Nashik, Kolhapur, Satara, Goa, and other tourist locations. Its stability on highways, comfortable suspension, and spacious interiors make long-distance travel enjoyable and fatigue-free."
  },
  {
    "title": "Wedding and Family Function Travel",
    "description": "For weddings and family events, Kia Carens provides elegant and comfortable transportation for relatives and guests. Its premium appearance, clean interiors, and smooth ride make it suitable for special occasions where comfort and presentation matter."
  },
  {
    "title": "Corporate Travel in Pune",
    "description": "Corporate clients prefer Kia Carens for meetings, conferences, office transfers, and client visits. The professional look, quiet cabin, and comfortable seating make it suitable for business travel across Pune and nearby industrial hubs."
  },
  {
    "title": "Local Sightseeing in Pune",
    "description": "Tourists and families exploring Pune’s attractions choose Kia Carens for local sightseeing as it offers comfort throughout the day, even during multiple stops and city traffic."
  },
  {
    "title": "Family Vacations and Group Trips",
    "description": "Kia Carens is ideal for family trips and vacations, providing sufficient space for children, elders, and luggage while ensuring a relaxed journey over long hours."
  },
  {
    "title": "Highway and Expressway Travel",
    "description": "The vehicle’s stability, safety features, and smooth handling make Kia Carens suitable for expressway and highway travel from Pune to major cities and tourist destinations."
  },
  {
    "title": "One-Day and Multi-Day Rentals",
    "description": "Kia Carens can be booked for single-day outings or extended multi-day trips, offering flexibility and convenience for all types of travel plans."
  },
  {
    "title": "Premium Local and Personal Travel",
    "description": "For premium personal travel, shopping trips, and special outings, Kia Carens offers a luxurious yet practical travel experience within Pune."
  }
]
,



"services": [
{
"name": "Kia Carens On Rent in Pune",
"description": "Kia Carens On Rent in Pune offers a premium and comfortable travel solution for families, corporate travelers, and tourists. With spacious seating, advanced safety features, and smooth performance, Kia Carens is ideal for airport transfers, city travel, weddings, corporate trips, and long-distance journeys. Sanavi Travels ensures clean vehicles, experienced drivers, punctual service, and transparent pricing, making every journey comfortable and stress-free."
},
{
"name": "Kia Carens Cab Hire Pune",
"description": "Kia Carens Cab Hire Pune provides flexible rental options for local, outstation, and special-purpose travel. This service is suitable for families, business professionals, and groups who prefer premium comfort and reliable transportation with professional chauffeur service."
},
{
"name": "AC Kia Carens On Rent Pune",
"description": "AC Kia Carens On Rent Pune ensures a cool, relaxed, and pleasant travel experience, especially during summer months and long-distance trips. Air-conditioned cabins, smooth suspension, and spacious interiors make it perfect for premium travel needs."
},
{
"name": "Non AC Kia Carens Hire Pune",
"description": "Non AC Kia Carens Hire Pune offers a budget-conscious option for travelers who prefer spacious vehicles without air-conditioning, while still enjoying comfort, safety, and professional service."
},
{
"name": "Kia Carens for Airport Transfer Pune",
"description": "Kia Carens for Airport Transfer Pune guarantees timely pickups, ample luggage space, and smooth rides, making airport travel comfortable and reliable for families and corporate travelers."
},
{
"name": "Kia Carens for Railway Pickup Pune",
"description": "Kia Carens for Railway Pickup Pune ensures stress-free transfers with enough space for passengers and luggage, ideal for early morning or late-night train schedules."
},
{
"name": "Kia Carens for Wedding Pune",
"description": "Kia Carens for Wedding Pune is suitable for transporting wedding guests, family members, and relatives comfortably during ceremonies, receptions, and associated events."
},
{
"name": "Kia Carens for Corporate Travel Pune",
"description": "Kia Carens for Corporate Travel Pune supports business travel, meetings, office transfers, and executive movement with a professional and premium travel experience."
},
{
"name": "Kia Carens for Outstation Pune",
"description": "Kia Carens for Outstation Pune offers dependable long-distance travel with comfortable seating, experienced drivers, and smooth highway performance."
},
{
"name": "Affordable Kia Carens Rental Pune",
"description": "Affordable Kia Carens Rental Pune provides premium vehicle experience at competitive pricing, ensuring value for money without compromising on comfort or service quality."
},
{
"name": "Best Kia Carens Cab Service Pune",
"description": "Best Kia Carens Cab Service Pune by Sanavi Travels is trusted for reliability, vehicle quality, courteous drivers, and customer satisfaction."
},
{
"name": "Kia Carens Hire with Driver Pune",
"description": "Kia Carens Hire with Driver Pune includes trained chauffeurs who manage traffic, navigation, and timing, allowing passengers to relax throughout the journey."
},
{
"name": "Kia Carens for Local Sightseeing Pune",
"description": "Kia Carens for Local Sightseeing Pune enables families and tourists to explore Pune comfortably, even on full-day sightseeing itineraries."
},
{
"name": "Kia Carens Family Trip Rental Pune",
"description": "Kia Carens Family Trip Rental Pune is ideal for family outings and vacations, offering space, comfort, and safety for all age groups."
},
{
"name": "Luxury Kia Carens Hire Pune",
"description": "Luxury Kia Carens Hire Pune delivers a premium travel experience with well-maintained vehicles, refined interiors, and professional service for special occasions."
}
],
"tableData": [
["Kia Carens On Rent in Pune", "Kia Carens Cab Hire Pune"],
["AC Kia Carens Pune", "Non AC Kia Carens Pune"],
["Kia Carens Airport Cab Pune", "Kia Carens Railway Pickup Pune"],
["Kia Carens Wedding Cab Pune", "Kia Carens Corporate Cab Pune"],
["Kia Carens Outstation Cab Pune", "Kia Carens Family Trip Pune"],
["Affordable Kia Carens Pune", "Best Kia Carens Cab Service Pune"],
["Luxury Kia Carens Pune", "Kia Carens with Driver Pune"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Kia Carens On Rent in Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable, premium, and comfortable Kia Carens rental services across Pune."
  },
  {
    "WhyChooseheading": "Spacious and Premium Interiors",
    "WhyChoosedescription": "Kia Carens provides ample legroom, modern interiors, and superior comfort for families and groups."
  },
  {
    "WhyChooseheading": "Professional Chauffeurs",
    "WhyChoosedescription": "Experienced drivers ensure safe driving, route knowledge, and punctual service."
  },
  {
    "WhyChooseheading": "Transparent and Affordable Pricing",
    "WhyChoosedescription": "Clear pricing with no hidden charges ensures complete peace of mind."
  },
  {
    "WhyChooseheading": "Multiple Travel Purposes Supported",
    "WhyChoosedescription": "Suitable for airport, railway, wedding, corporate, sightseeing, and outstation travel."
  },
  {
    "WhyChooseheading": "Clean and Sanitized Vehicles",
    "WhyChoosedescription": "Vehicles are thoroughly cleaned and sanitized before every trip."
  },
  {
    "WhyChooseheading": "24/7 Booking and Support",
    "WhyChoosedescription": "Round-the-clock customer support for bookings and travel assistance."
  },
  {
    "WhyChooseheading": "Reliable and Punctual Service",
    "WhyChoosedescription": "On-time pickups and smooth journey execution every time."
  }
]

}

const faqData = [
  {
    question: 'Do you provide Kia Carens on rent in Pune?',
    answer: 'Yes, Sanavi Travels offers Kia Carens on rent across Pune for various travel needs.'
  },
  {
    question: 'Is AC Kia Carens available?',
    answer: 'Yes, both AC and Non-AC Kia Carens vehicles are available.'
  },
  {
    question: 'Can I book Kia Carens for outstation travel?',
    answer: 'Yes, Kia Carens can be booked for outstation and long-distance trips.'
  },
  {
    question: 'Is driver included in Kia Carens booking?',
    answer: 'Yes, all bookings include experienced and professional drivers.'
  },
  {
    question: 'Is Kia Carens suitable for family travel?',
    answer: 'Yes, Kia Carens is ideal for family trips due to its comfort and spacious design.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Anil Deshmukh',
    feedback: 'Booked Kia Carens for our family trip from Pune. Very comfortable and smooth experience.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Pooja Kulkarni',
    feedback: 'Excellent Kia Carens cab service for airport transfer. Clean car and professional driver.',
    rating: 5
  }
];



























  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];






// const jsonData = {
//   "@context": "https://schema.org",
//   "@type": "Product",
//   "name": "Kia Carens On Rent in Pune - Sanavi Travels",
//   "description": "Sanavi Travels offers Kia Carens on rent in Pune for airport transfers, railway station pickups, weddings, corporate travel, outstation trips, local sightseeing, and family trips. AC and Non-AC Kia Carens are available with professional drivers at affordable rates.",
//   "aggregateRating": {
//     "@type": "AggregateRating",
//     "bestRating": "5",
//     "worstRating": "1",
//     "ratingValue": "4.7",
//     "ratingCount": "10000+"
//   }
// };


const jsonData = {
  "@context": "https://schema.org",
  "@type": "Service",
  "@id":
    "https://www.sanavitravels.com/Kia-Carens-On-Rent-in-Pune#service",

  "name": "Kia Carens On Rent in Pune",

  "serviceType": "Kia Carens Rental",

  "description":
    "Sanavi Travels offers Kia Carens on rent in Pune for family trips, airport transfers, corporate travel, weddings, local travel and outstation journeys with a professional driver.",

  "provider": {
    "@type": "LocalBusiness",
    "@id": "https://www.sanavitravels.com/#business",
    "name": "Sanavi Travels",
    "url": "https://www.sanavitravels.com/",
    "telephone": "+91-7387507373"
  },

  "areaServed": {
    "@type": "City",
    "name": "Pune",
    "containedInPlace": {
      "@type": "State",
      "name": "Maharashtra",
      "containedInPlace": {
        "@type": "Country",
        "name": "India"
      }
    }
  },

  "url":
    "https://www.sanavitravels.com/Kia-Carens-On-Rent-in-Pune"
};







  return (
    <div>

<Helmet>
  <title>
    Kia Carens On Rent in Pune | Kia Carens Rental | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book Kia Carens on rent in Pune with Sanavi Travels for family trips, airport transfers, corporate travel, weddings, local travel and outstation journeys with a professional driver."
  />

  <meta
    name="keywords"
    content="Kia Carens On Rent in Pune, Kia Carens Rental Pune, Kia Carens Hire Pune, Kia Carens Cab Pune, Kia Carens Taxi Pune, Kia Carens for Outstation Pune, Kia Carens Airport Cab Pune"
  />

  <link
    rel="canonical"
    href="https://www.sanavitravels.com/Kia-Carens-On-Rent-in-Pune"
  />

  {/* Open Graph */}
  <meta
    property="og:type"
    content="website"
  />

  <meta
    property="og:title"
    content="Kia Carens On Rent in Pune | Kia Carens Rental | Sanavi Travels"
  />

  <meta
    property="og:description"
    content="Rent a Kia Carens in Pune for family travel, airport transfers, corporate trips, weddings, local travel and outstation journeys with a professional driver."
  />

  <meta
    property="og:url"
    content="https://www.sanavitravels.com/Kia-Carens-On-Rent-in-Pune"
  />

  <meta
    property="og:image"
    content="https://www.sanavitravels.com/images/kia-carens-on-rent-in-pune.jpg"
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


{/* <Helmet>
  <title>
    Call : +91 7387507373 | Kia Carens On Rent in Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book Kia Carens on rent in Pune with Sanavi Travels. AC & Non-AC Kia Carens for airport, railway, wedding, corporate, outstation, sightseeing, and family trips with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet> */}

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/kia-carens-on-rent-in-pune.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Kiacarensonrentinpune;